import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import { BaseUrl } from "../../../../Container/BaseUrl/BaseUrl";
import { connect } from "react-redux";
import {} from "../../../../Redux/Actions/actions";
// chat style
import "../../../../Assets/style/components/audiochat.scss";
import Nodata from "../../../../Assets/images/svg/Data-unavailable.svg";

// import "../../Chat-component/Chat-Style/chat.css";
import {
  TableRow,
  styled,
  IconButton,
  Stack,
  Box,
  Pagination,
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import {
  ChatsCircle,
  Envelope,
  Eye,
  FacebookLogo,
  Phone,
  Robot,
  TwitterLogo,
  VideoCamera,
} from "@phosphor-icons/react";
import SummeryComponent from "../Summery-component/SummeryComponent";
import { Spinner } from "react-bootstrap";
import { TiWarningOutline } from "react-icons/ti";
import {
  StyledTable,
  StyledTableBody,
  StyledTableContainer,
  StyledTableHead,
  StyledTableRow,
} from "../../../../CustomComponent/TableCompoent";
import { Hourglass } from "react-loader-spinner";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#eff5fc",
    padding: "10px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#0b3363",
    borderBottom: "0",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));
const StyledTableCell2 = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.root}`]: {
    backgroundColor: "#FFFF",
    color: theme.palette.common.black,
    padding: "5px",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
  },
}));

const mapStateToProps = (state) => {
  const { contactListData } = state;
  return {
    externalChatData: contactListData.externalChatData,
  };
};

const InteractionTabTableFormat = (props) => {
  var someDate = new Date();
  var date = someDate.setDate(someDate.getDate());
  var defaultValue = new Date(date).toISOString().split("T")[0];
  const [showSummery, setShowSummery] = useState(false);
  const [sessionVal, setsessionVal] = useState([]);
  const [summerydata, setsummerydata] = useState();
  const [loader, setloader] = useState(false);
  const [pagination, setPagination] = useState(0);
  const [page, setPage] = useState(1);

  const getSessionsDetails = async (value) => {
    setloader(true);
    await axios
      .post(
        BaseUrl + "/message/getSessions/",
        {
          email: props.externalChatData ? props.externalChatData.email : "",
          phonenumber: props.externalChatData
            ? props.externalChatData.phonenumber
            : "",
          date: value,
          limit: 10,
          offset: page == 1 ? 0 : (page - 1) * 10,
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("access_token"),
            "Content-Type": "application/json",
            tenantId: localStorage.getItem("TenantId"),
          },
        }
      )
      .then((res) => {
        if (res.data.success) {
          setsessionVal(res.data.data);
          setPagination(res.data.count);
          setloader(false);
        } else {
          setsessionVal([]);
          setPagination(res.data.count);
           setloader(false);
        }
      });
  };
  const handleChange = (event, value) => {
    setPage(value);
    getSessionsDetails()
  };
  const handleShowDetails = async (session_id) => {
    const access_token = localStorage.getItem("access_token");
    let data = {
      sessionId: session_id,
    };
    await axios
      .post(BaseUrl + "/message/getSummery/", data, {
        headers: {
          Authorization: "Bearer " + access_token,
          "Content-Type": "application/json",
          tenantId: localStorage.getItem("TenantId"),
        },
      })
      .then((sessions) => {
        if (sessions.data.success) {
          setsummerydata(sessions.data.data);
          setShowSummery(true);
        } else {
          setsummerydata();
          setShowSummery(false);
        }
      })
      .catch((err) => {
        console.log("handleShowDetails", err);
      });
  };
  useEffect(() => {
    getSessionsDetails(defaultValue);
  }, [props.externalChatData]);

  return (
    <>
      <div
        className="historynew CONTACT-LIST-AREA"
        style={{
          height: "100%",
          width: "100%",
        }}
      >
        <StyledTableContainer sx={{ height: "85%", width: "100%" }}>
          <StyledTable stickyHeader aria-label="sticky table">
            <StyledTableHead>
              <StyledTableRow>
                {[
                  "Channel",
                  "Agent",
                  "Language",
                  "Date",
                  "Skillset",
                  "Disposition",
                  "Time",
                  "View",
                ].map((headers, index) => (
                  <StyledTableCell align="center" key={index}>
                    {headers}
                  </StyledTableCell>
                ))}
              </StyledTableRow>
            </StyledTableHead>
            <StyledTableBody sx={{ position: "relative" }}>
              {loader ? (
                <Stack sx={{ position: "absolute", top: "50%", left: "50%" }}>
                  <Hourglass
                    visible={true}
                    height="30"
                    width="30"
                    ariaLabel="hourglass-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                    colors={["#2268a0", "#72a1ed"]}
                  />
                </Stack>
              ) : sessionVal.length > 0 ? (
                sessionVal.map((item, rowIndex) => (
                  <TableRow hover role="checkbox" tabIndex={-1} key={rowIndex}>
                    <StyledTableCell2 align="center">
                      {(() => {
                        switch (item.channel) {
                          case "webchat":
                            return (
                              <div className="box d-flex align-items-center justify-content-center sms-bg">
                                <ChatsCircle size={18} weight="bold" />
                              </div>
                            );
                          case "from_whatsapp":
                            return (
                              <div className="box d-flex align-items-center justify-content-center sms-bg">
                                <ChatsCircle size={18} weight="bold" />
                              </div>
                            );
                          case "from_facebook":
                            return (
                              <div className="box d-flex align-items-center justify-content-center fb-bg">
                                <FacebookLogo size={18} weight="bold" />
                              </div>
                            );
                          case "from_twitter":
                            return (
                              <div className="box d-flex align-items-center justify-content-center twit-bg">
                                <TwitterLogo size={18} weight="bold" />
                              </div>
                            );
                          case "from_teams":
                            return (
                              <div className="box d-flex align-items-center justify-content-center teams-bg">
                                <ChatsCircle size={18} weight="bold" />
                              </div>
                            );
                          case "videochat":
                            return (
                              <div className="box d-flex align-items-center justify-content-center twit-bg">
                                <VideoCamera size={18} weight="bold" />
                              </div>
                            );
                          case "voice":
                            return (
                              <div className="box d-flex align-items-center justify-content-center twit-bg">
                                <Phone size={18} weight="bold" />
                              </div>
                            );
                          case "from_purple":
                            return (
                              <div className="box d-flex align-items-center justify-content-center twit-bg">
                                <Robot size={18} weight="bold" />
                              </div>
                            );
                          default:
                            return (
                              <div className="box d-flex  align-items-center justify-content-center call-bg">
                                <Envelope size={18} weight="bold" />
                              </div>
                            );
                        }
                      })()}
                    </StyledTableCell2>
                    <StyledTableCell2 align="center">
                      {item.agent ? item.agent.username : ""}
                    </StyledTableCell2>
                    <StyledTableCell2 align="center">
                      {item.language}
                    </StyledTableCell2>
                    <StyledTableCell2 align="center">
                      {moment(item.chat_started_at).format("DD/MM/YYYY")}
                    </StyledTableCell2>
                    <StyledTableCell2 align="center">
                      {item.skillset ? item.skillset : "NA"}
                    </StyledTableCell2>
                    <StyledTableCell2 align="center">
                      {item.reason ? item.reason : "NA"}
                    </StyledTableCell2>
                    <StyledTableCell2 align="center">
                      {item.chat_started_at
                        ? moment(item.chat_started_at).format("hh:mm:ss a")
                        : "--"}
                    </StyledTableCell2>
                    <StyledTableCell2 align="center">
                      <IconButton
                        onClick={() => handleShowDetails(item.chat_session_id)}
                      >
                        <Eye size={14} weight="bold" />
                      </IconButton>
                    </StyledTableCell2>
                  </TableRow>
                ))
              ) : (
                <Stack
                  sx={{
                    position: "absolute",
                    width: "100%",
                    height: "calc(100vh - 14rem)",
                  }}
                  justifyContent="center"
                  alignContent="center"
                >
                  <Stack
                    className="text-muted"
                    direction="column"
                    justifyContent="center"
                    alignContent="center"
                  >
                    <span className="mx-auto">
                      <img
                        src={Nodata}
                        alt="pic"
                        style={{ width: "11rem", userSelect: "none" }}
                      />
                    </span>
                    <span className="mx-auto">
                      <h6
                        className="text-muted mt-3"
                        style={{ fontSize: "13px" }}
                      >
                        Data unavailable
                      </h6>
                    </span>
                  </Stack>
                </Stack>
              )}
            </StyledTableBody>
          </StyledTable>
        </StyledTableContainer>

        <div
          className="card-footer border-0"
          style={{
            height: "calc(100% - 85%)",
            padding: "2px 5px",
          }}
        >
          <Stack
            sx={{ width: "100%", height: "100%" }}
            direction={"row"}
            alignItems={"center"}
            justifyContent={"space-between"}
          >
            <input
              style={{ width: "150px" }}
              type="Date"
              max={defaultValue}
              className="form-control form-control-sm"
              onChange={(e) => {
                getSessionsDetails(e.target.value);
              }}
            />
            <Pagination
              count={Math.ceil(pagination / 10)}
              page={page}
              shape="rounded"
              color="primary"
              size="small"
              style={{ float: "right" }}
              onChange={handleChange}
            />
          </Stack>
        </div>
      </div>

      {showSummery && (
        <SummeryComponent
          OpenDialog={showSummery}
          summerydata={summerydata}
          handleClose={() => {
            setShowSummery(false);
          }}
        />
      )}
    </>
  );
};

export default connect(mapStateToProps, {})(InteractionTabTableFormat);